import { actionSet } from './utils'
import { getPages, getPaginationUrl } from 'component/pagination/utils'
import { hideSpinner, showSpinner } from './spinner'
import {
  FETCH_PRICEBANNER_CONFIG_SUCCESS,
  FETCH_PRICEBANNER_CONFIG_ERROR,
  SAVE_PRICEBANNER_CONFIG_SUCCESS,
  SAVE_PRICEBANNER_CONFIG_ERROR,
  DELETE_PRICEBANNER_CONFIG_SUCCESS,
  DELETE_PRICEBANNER_CONFIG_ERROR,
} from 'constants/actionTypes'
import API_URL from 'constants/api'
import Api from 'utils/ApiRequest'

export const fetch = (token, param) => async (dispatch) => {
  try {
    dispatch(showSpinner())

    let api = API_URL.FETCH_PRICEBANNER_CONFIG

    if (param.hasPagination) {
      api = getPaginationUrl(api, param.page, param.size)
    }

    const response = (await new Api(token, dispatch).post(api, param)) || {}

    const { data } = response

    dispatch(getPages(data.pages))

    return dispatch(
      actionSet(FETCH_PRICEBANNER_CONFIG_SUCCESS, data.resultList || [])
    )
  } catch (error) {
    return dispatch(actionSet(FETCH_PRICEBANNER_CONFIG_ERROR, error))
  } finally {
    dispatch(hideSpinner())
  }
}

export const save = (token, param) => async (dispatch) => {
  try {
    dispatch(showSpinner())

    const response = await new Api(token, dispatch).post(
      API_URL.SAVE_PRICEBANNER_CONFIG,
      param
    )

    const { data } = response

    return dispatch(actionSet(SAVE_PRICEBANNER_CONFIG_SUCCESS, data))
  } catch (error) {
    return dispatch(actionSet(SAVE_PRICEBANNER_CONFIG_ERROR, error))
  } finally {
    dispatch(hideSpinner())
  }
}

export const remove = (token, param) => async (dispatch) => {
  try {
    dispatch(showSpinner())

    await new Api(token, dispatch).post(
      API_URL.DELETE_PRICEBANNER_CONFIG,
      param
    )

    return dispatch(actionSet(DELETE_PRICEBANNER_CONFIG_SUCCESS))
  } catch (error) {
    return dispatch(actionSet(DELETE_PRICEBANNER_CONFIG_ERROR, error))
  } finally {
    dispatch(hideSpinner())
  }
}
